const workflowTemplateTask = {
  id: null,
  workflowTemplateId: null,
  title: null,
  description: null,
  defaultAssigneeRoleId: null,
  dueDateAnchorId: null,
  dueDateAnchorName: null,
  dueDateOffsetDays: 0,
  blockerTaskId: null,
  blockerTaskTitle: null,
  sortOrder: 0,
  isActive: true,
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null
}

export default () => Object.assign({}, workflowTemplateTask)
